import { createApp } from "vue";
import App from "@/App.vue";
import drag from "v-drag";
import DraggableResizableVue3 from "draggable-resizable-vue3";
import "../public/scss/main.scss";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const app = createApp(App);

/**
 * ドラッグアンドドロップライブラリ
 */
app.use(drag, { eventClass: {} });
app.component("draggable-resizable-vue3", DraggableResizableVue3);

/**
 * カレンダーライブラリ
 */
app.component("VueDatePicker", VueDatePicker);

app.mount("#app");
